<template>
  <el-dialog
    :title="$t('editJob.editTask')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="editJobInfo" label-width="120px">
      <el-form-item :label="$t('editJob.taskName')" required>
        <el-input
          v-model="editJobInfo.taskName"
          :placeholder="$t('editJob.enterTaskName')"
        />
      </el-form-item>
      <el-form-item :label="$t('editJob.selectTemplate')" required>
        <el-select
          v-model="editJobInfo.templateId"
          @change="chooseEditTemplate"
          :placeholder="$t('editJob.selectTemplatePlaceholder')"
          style="width:100%"
        >
          <el-option
            v-for="item in editJobInfo.templates"
            :key="item.templateId"
            :label="item.templateName"
            :value="item.templateId"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editJob.timing')">
        <el-input
          v-model="editJobInfo.taskCron"
          :placeholder="$t('editJob.enterTiming')"
        />
      </el-form-item>
      <el-form-item
        v-for="(item, index) in editJobInfo.templateSpecs"
        :key="index"
        :label="item.specName"
      >
        <el-input
          v-model="item.value"
          :placeholder="item.specDesc"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editJob">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listTaskTemplate, listTaskTemplateSpec, updateTask } from '@/api/dev/jobApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditJob',
  data() {
    return {
      dialogVisible: false,
      editJobInfo: {
        taskId: '',
        taskName: '',
        templateId: '',
        taskCron: '',
        taskAttr: [],
        templates: [],
        templateSpecs: []
      }
    }
  },
  methods: {
    open(job) {
      this.dialogVisible = true
      this.editJobInfo = {
        ...this.editJobInfo,
        ...job,
        templateId: job.templateId
      }
      this.queryEditTemplate()
    },
    handleClose() {
      this.editJobInfo = {
        taskId: '',
        taskName: '',
        templateId: '',
        taskCron: '',
        taskAttr: [],
        templates: [],
        templateSpecs: []
      }
    },
    async queryEditTemplate() {
      try {
        const res = await listTaskTemplate({
          page: 1,
          row: 30
        })
        this.editJobInfo.templates = res.data
        this.chooseEditTemplate()
      } catch (error) {
        console.error('获取模板列表失败:', error)
      }
    },
    async chooseEditTemplate() {
      try {
        const res = await listTaskTemplateSpec({
          templateId: this.editJobInfo.templateId,
          isShow: 'T'
        })
        
        this.editJobInfo.templateSpecs = res.data.map(item => {
          const attr = this.editJobInfo.taskAttr.find(attr => 
            attr.specCd === item.specCd && 
            attr.templateId === this.editJobInfo.templateId
          )
          return {
            ...item,
            value: attr ? attr.value : '',
            attrId: attr ? attr.attrId : ''
          }
        })
      } catch (error) {
        console.error('获取模板规格失败:', error)
      }
    },
    async editJob() {
      if (!this.validate()) {
        return
      }

      try {
        const params = {
          ...this.editJobInfo,
          shopId: getShopId()
        }
        await updateTask(params)
        this.$message.success(this.$t('editJob.editSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('修改任务失败:', error)
      }
    },
    validate() {
      if (!this.editJobInfo.taskName) {
        this.$message.error(this.$t('editJob.taskNameRequired'))
        return false
      }
      if (!this.editJobInfo.templateId) {
        this.$message.error(this.$t('editJob.templateRequired'))
        return false
      }
      return true
    }
  }
}
</script>